export default __webpack_public_path__ + "static/media/malovanie-na-tvar.d311ab0a.svg";